import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "@emotion/core"
import Typewriter from "typewriter-effect"

const Banner = props => {
  const { coverbg } = useStaticQuery(graphql`
    query {
      coverbg: file(relativePath: { eq: "corm-wallpaper.jpg" }) {
        publicURL
      }
    }
  `)

  return (
    <div
      id="home"
      css={css`
        min-height: 100vh;
        height: 100%;
        width: 100%;
        background-color: #18069c;
        position: relative;
      `}
    >
      <div
        css={css`
          height: 100vh;
          width: 100%;
          background: url(${coverbg.publicURL});
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          opacity: 0.5;
        `}
      ></div>
      <h2
        css={css`
          position: absolute;
          top: calc(45vh);
          right: calc(10vw);
          color: white;
          font-size: 70px;
        `}
      >
        <Typewriter
          options={{
            strings: props.headers,
            autoStart: true,
            loop: true,
            delay: 50
          }}
        />
      </h2>
    </div>
  )
}

export default Banner
